import React from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import moment from "moment";
import DataGrid, { Column, HeaderFilter, Paging, Pager } from "devextreme-react/ui/data-grid";
import validaciones from "../../../../../helpers/validaciones";

class TablaBaterias extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="contenedor-master-detail">
          <div>Sin Información</div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorEmpresas.isLoading,
  listaEmpresas: state.mantenedorEmpresas.listaEmpresas,
  listaEmpresasFiltradas: state.mantenedorEmpresas.listaEmpresasFiltradas,
  filtrosEmpresas: state.mantenedorEmpresas.filtrosEmpresas,
  empresa: state.mantenedorEmpresas.empresa
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TablaBaterias);
